export const X_AXIS_DATA_KEY = "name";
export const X_AXIS_DATA_KEY_TWO = "nameTwo";
export const Y_AXIS_DATA_KEY = "name";
export const PIECHART_VALUE_DATA_KEY = "Count";
